
import { mapState, mapMutations } from 'vuex'

export default {
  head() {
    return this.$metadata(this.story)
  },
  data() {
    return {
      story: {}
    }
  },
  async mounted() {
    const eventData = {
      event: 'view_menu',
      currency: 'USD'
    }

    if (this.order && this.order.products) {
      eventData.items = this.order.products
      eventData.value = this.order.totals.total
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      ...eventData
    });

    this.$storybridge.on(['input', 'published', 'change'], (event) => {
      if (event.action === 'input') {
        if (event.story.id === this.story.id) {
          this.story.content = event.story.content
        }
      } else {
        window.location.reload()
      }
    })

    if (!this.menu) {
      this.$router.push('/locations')
    }
  },
  beforeMount() {
    if (this.menu && this.deeplinkProduct) {
      const product = this.matchProduct()
      if (product) {
        this.$router.push(`/order/product?id=${product.sku}`)
        this.setDeeplinkProduct(null)
        this.setDeeplinkProductNotFoundAtLocation(false)
      } else {
        this.setDeeplinkProductNotFoundAtLocation(true)
      }
    }
  },
  async asyncData({ $storyapi, store, route }) {
    try {
      const { data } = await $storyapi.get(`cdn/stories/${route.name}`, {
        version: process.env.SB_VERSION
      })
      return {
        story: data.story
      }
    } catch (error) {
      console.error(error)
    }
  },
  computed: {
    ...mapState(['menu', 'order', 'channel', 'location', 'deeplinkProduct', 'deeplinkProductNotFoundAtLocation'])
  },
  methods: {
    ...mapMutations(['setDeeplinkProduct', 'setDeeplinkProductNotFoundAtLocation']),
    matchProduct() {
      if (!this.deeplinkProduct || !this.menu?.categories) {
        return null
      }

      // Normalize function to clean up strings for comparison
      const normalize = str => {
        return str
          .toLowerCase()
          .replace(/®/g, '')
          .replace(/&/g, 'and')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '')
      }

      // Clean and normalize the deeplink product name (remove time data and normalize)
      const cleanDeeplinkName = this.deeplinkProduct.name.split(' - ')[0].trim()
      const targetNormalized = normalize(cleanDeeplinkName)
      
      let bestMatch = null
      let bestScore = Infinity

      // Levenshtein distance function for fuzzy matching
      const levenshtein = (a, b) => {
        const matrix = []
        for (let i = 0; i <= b.length; i++) {
          matrix[i] = [i]
        }
        for (let j = 0; j <= a.length; j++) {
          matrix[0][j] = j
        }
        for (let i = 1; i <= b.length; i++) {
          for (let j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
              matrix[i][j] = matrix[i - 1][j - 1]
            } else {
              matrix[i][j] = Math.min(
                matrix[i - 1][j - 1] + 1,
                matrix[i][j - 1] + 1,
                matrix[i - 1][j] + 1
              )
            }
          }
        }
        return matrix[b.length][a.length]
      }

      // Search through all products in the menu
      for (const category of this.menu.categories) {
        for (const product of category.products) {
          // Clean product name by removing time data (everything after ' - ')
          const cleanName = product.name.split(' - ')[0].trim()
          const productNormalized = normalize(cleanName)

          // Calculate similarity score
          const score = levenshtein(productNormalized, targetNormalized)

          // Keep track of the best match
          if (score < bestScore) {
            bestScore = score
            bestMatch = product
          }
        }
      }

      // Only return a match if the score is reasonable (threshold of 3)
      if (bestMatch && bestScore <= 3) {
        console.log(`Found closest match: ${bestMatch.name} (score: ${bestScore}) for target: ${cleanDeeplinkName}`)
        return bestMatch
      }

      console.log(`No close match found for: ${cleanDeeplinkName} (normalized: ${targetNormalized})`)
      return null
    }
  }
}
